<template>
  <component
    :is="isNewWindow ? 'router-link' : 'div'"
    :target="isNewWindow"
    class="bbp-string-cell"
    @click.stop="clickCell"
    :to="routerTo"
  >
    <i
      v-if="column.updateProject && displayCompleteIcon"
      class="bbp-icon-plus bbp-string-cell-update"
      :class="{'bbp-string-cell-update_disabled': row.disabled}"
       @click.stop="updateProject"
    />
    <span
      class="bbp-string-cell-text"
      :class="{
        'bbp-string-cell-text_with-hover': column.route || column.hover,
        'bbp-string-cell-text_tag': column.styles === 'tag',
      }"
      :id="`bbp-string-cell-id_${row._id}_${column.id}`"
      :style="customStyle"
    >
      {{value}}
    </span>
    <div
      v-if="iconDisplay.property && activeStatus === 1"
      class="bbp-string-cell-alert"
    >
      <div
        class="bbp-string-cell-alert__icon"
        @mouseenter="setShowInfo($event, true)"
        @mouseleave="setShowInfo($event, false)"
      >
        <BBPIconExclamationPoint/>
        <transition name="bbp-bounce">
          <BBPProjectPopUpInfo
            v-if="showInfo"
            :title="rejectTitle"
            :style="positionInfo"
            :descriptionReject="iconDisplay.comments"
          />
        </transition>
      </div>
    </div>
    <div
      v-if="markDisplay"
      class="bbp-string-cell-mark"
      @mouseenter="onMouseenter($event)"
      @mouseleave="onMouseleave"
    >
      {{markDisplay}}
    </div>
    <div
      v-if="displayNotification && (notificationText || popupText)"
      class="bbp-string-cell-notification"
      @mouseenter="setShowInfo($event, true)"
      @mouseleave="setShowInfo($event, false)"
    >
      <span
        v-if="displayNotification && hasNotification"
        class="bbp-string-cell-notification bbp-string-cell-notification_circle"
      />
      <BBPIconDescription />
      <transition name="bbp-bounce">
        <BBPProjectPopUpInfo
          v-if="showInfo"
          :text="notificationText"
          :description="popupText"
          :style="positionInfo"
          :title="descriptionText"
          :subTitle="updateText"
          :isDynamic="isDynamic"
        />
      </transition>
    </div>
    <BBPFileCell
      v-if="withFile"
      class="bbp-string-cell__file"
      :row="row"
      :column="column"
      :from-params="true"
    />
     <div
        v-show="isShowModalOnKpi && isHover && currentTextKpi"
        :style="popupPosition"
        class="bbp-string-cell-popup"
        :ref="`bbp-string-cell-popup-${row._id}`"
        @mouseenter="onClearTimeout"
        @mouseleave="isHover = false"
        @click.stop="onClickPopup"
      >
        {{currentTextKpi}}
      </div>
    <HashtagCell
      v-if="hashtag"
      :items="hashtag"
      :value="value"
      :rowId="row._id"
      :columnId="column.id"
      @onFilterTag="onFilterTag"
    />
  </component>
</template>

<script>
import {get, includes, compact} from 'lodash'
import notificationImage from '@/assets/images/notification.png'
import BBPIconExclamationPoint from '@/components/Main/BBPIcons/BBPIconExclamationPoint'
import BBPIconDescription from '@/components/Main/BBPIcons/BBPIconDescription'
import BBPFileCell from '@/components/Main/BBPTable/BBPFileCell/BBPFileCell'
import {IN_PROGRESS_PROJECT} from '@/constants/projectStatuses'
import BBPProjectPopUpInfo from '@/components/Main/BBPProjectPopUpInfo/BBPProjectPopUpInfo'
import {HOURLY, SIDE_HOURLY} from '@/constants/projectTypes'
import HashtagCell from '@/components/Main/BBPTable/BBPStringCell/HashtagCell'

export default {
  name: 'BBPStringCell',
  props: ['row', 'column', 'index'],
  components: {
    HashtagCell,
    BBPProjectPopUpInfo,
    BBPFileCell,
    BBPIconExclamationPoint,
    BBPIconDescription
  },
  data () {
    return {
      showInfo: false,
      iconInfo: false,
      descriptionText: 'Project description',
      updateText: 'Last update',
      rejectTitle: 'Reason for rejection',
      positionInfo: {},
      notificationImage: notificationImage,
      popupPosition: {},
      isHover: false
    }
  },
  computed: {
    isHourlyProject () {
      const type = get(this.row, 'projectType.id', '')
      return type === HOURLY.id || type === SIDE_HOURLY.id
    },
    activeStatus () {
      return get(this.row, 'status', 0)
    },
    displayCompleteIcon () {
      return this.row.status === IN_PROGRESS_PROJECT.id
    },
    withFile () {
      return get(this.column, 'file.prop', '')
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    popupText () {
      const prop = get(this.column, 'popup', '')
      const prefix = get(this.column, 'popupPrefix', '')
      const value = get(this.row, prop, '')
      return value ? `${prefix} ${value}` : ''
    },
    notificationText () {
      const prop = get(this.column, 'notificationPopup', '')
      return get(this.row, prop, '')
    },
    customStyle () {
      const { customStyle } = this.column
      return customStyle
    },
    value () {
      const fromProp = get(this.row, this.column.prop, '')
      const prefix = get(this.column, 'prefix', '')
      const value = get(this.row, this.column.display, fromProp)
      return prefix + value
    },
    info () {
      return compact(get(this.row, this.column.info, []))
    },
    iconDisplay () {
      const prop = get(this.column, 'icon.model', false)
      const statusReject = get(this.row, prop, false)
      const model = get(this.column, 'icon.popup', '')
      const text = get(this.row, model, [])
      return {
        property: statusReject,
        comments: text
      }
    },
    hashtag () {
      const isHashtag = get(this.column, 'isHashtag', '')
      if (!isHashtag) return false
      const tags = get(this.row, isHashtag, [])
      if (!tags.length) return false
      tags.sort((a, b) => a.name.length - b.name.length)
      tags.forEach((el, index) => {
        if (tags[index - 1]) {
          const beforeItemLength = tags[index - 1].length
          el.length = (el.name.length * 9) + beforeItemLength + 8
        } else {
          el.length = el.name.length * 9
        }
      })
      return tags
    },
    markDisplay () {
      const prop = get(this.column, 'mark.display', [])
      const text = get(this.column, 'mark.text', [])
      const index = prop.findIndex(item => get(this.row, item, ''))
      if (index !== -1) {
        return text[index] || false
      }
      return false
    },
    isShowModalOnKpi () {
      return get(this.column, 'popup.isShowModalOnKpi', false)
    },
    currentTextKpi () {
      const value = get(this.column, 'popup.text', '')
      return get(this.row, value, '')
    },
    displayNotification () {
      return get(this.column, 'notification', '')
    },
    hasNotification () {
      const userID = get(this.userInfo, 'id', '')
      const notificationId = get(this.row, '$notification._id', '')
      const readUsers = get(this.row, '$notification.readUsers', [])
      return !includes(readUsers, userID) && notificationId
    },
    projectUserId: {
      get () {
        return this.$store.getters.projectUserId
      },
      set (data) {
        this.$store.dispatch('setProjectUserId', data)
      }
    },
    isSubProject () {
      const { projectType = {} } = this.row
      return projectType.id === SIDE_HOURLY.id
    },
    isRoute () {
      const isRoute = get(this.column, ['route', 'name'], '')
      return isRoute
    },
    routerTo () {
      const router = {}

      const paramName = get(this.column, ['route', 'paramName'], '')
      const paramName2 = get(this.column, ['route', 'paramName2'], '')

      const paramProp = get(this.column, ['route', 'paramValue'], '')
      const paramProp2 = get(this.column, ['route', 'paramValue2'], '')
      const paramValue = get(this.row, paramProp, '')
      const paramValue2 = get(this.row, paramProp2, '')

      if (paramName === 'projectId' && this.isSubProject) {
        const { parentProjectId } = this.row
        router.params = {
          [paramName]: parentProjectId
        }
      } else if (paramName && paramValue) {
        router.params = {
          [paramName]: paramValue
        }
      }

      if (paramName2 && paramValue2) {
        router.params = {
          ...router.params,
          [paramName2]: paramValue2
        }
      }

      return {
        name: this.isRoute,
        params: router.params
      }
    },
    isNewWindow () {
      const newWindow = get(this.column, ['route', 'newWindow'], '')
      return newWindow ? '_blank' : ''
    },
    isDynamic () {
      const { isDynamic = false } = this.column
      return isDynamic
    }
  },
  methods: {
    onFilterTag (id) {
      this.$emit('filter', {row: this.row, column: this.column, newVal: id})
    },
    updateProject () {
      const currentElem = {row: this.row, column: this.column, index: this.index}
      this.$emit('updateProject', currentElem)
    },
    setShowInfo (e, val, target) {
      if (target) {
        this.iconInfo = val
        this.showInfo = false
      } else {
        this.iconInfo = false
        this.showInfo = val
      }
      const position = e.target.getBoundingClientRect()
      if (val && position) {
        this.positionInfo = {
          position: 'fixed',
          top: position.top + position.height + 8 + 'px',
          left: position.left + 'px'
        }
        this.$nextTick(this.setStylePopup)
      } else {
        this.positionInfo = {}
      }
    },
    setStylePopup () {
      setTimeout(() => {
        const textNode = get(this.$refs, ['BBPopup', 'childNodes', 0], {})
        const width = textNode.offsetWidth ? textNode.offsetWidth + 16 + 'px' : 'auto'
        this.$set(this.positionInfo, 'width', width)
      }, 100)
    },
    clickCell () {
      if (this.isRoute && !this.isNewWindow) this.goToRoute()
      if (this.isRoute) return
      const action = get(this.column, 'action', '')
      if (action && typeof action === 'function') action(this.row, this.column)
    },
    goToRoute () {
      this.$router.push(this.routerTo)
    },
    onMouseleave () {
      this.timer = setTimeout(() => {
        this.isHover = false
        this.popupPosition = {}
      }, 400)
    },
    onMouseenter ({target}) {
      this.isHover = true
      const {top, height, left, width} = target.getBoundingClientRect()
      const popupElement = this.$refs[`bbp-string-cell-popup-${this.row._id}`]

      setTimeout(() => {
        const {width: widthPopup} = popupElement.getBoundingClientRect()
        this.popupPosition = {
          ...this.popupPosition,
          left: `${left - (widthPopup / 2) + (width / 2)}px`,
          opacity: 1
        }
      }, 100)

      this.popupPosition = {
        position: 'fixed',
        top: `${top + height + 8}px`,
        opacity: 0,
        transition: 'opacity 0.3s'
      }
    },
    onClearTimeout () {
      clearTimeout(this.timer)
    },
    onClickPopup () {
      const prop = get(this.column, 'popup.prop', '')
      const value = get(this.row, prop, '')
      this.projectUserId = this.projectUserId === value ? '' : value
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-string-cell {
    @include global-font;
    display: flex;
    align-items: center;
    position: relative;
    text-decoration: none;
    color: $color-black;

    &-alert {
      padding-left: 5px;

      &__icon {
        display: flex;
        position: relative;
        cursor: pointer;
        transition: .3s;

        &:hover {
          opacity: 0.8;
        }
      }
    }

    &-text {
      display: flex;
      align-items: center;

      &_with-hover {
        cursor: pointer;
        transition: 0.3s;

        &:hover {
          color: $color-accent;
        }
      }

      &_tag {
        display: inline-block;
        padding: 4px 6px;
        background: $color-link-water;
        color: $color-accent;
        border-radius: 4px;
        font-weight: normal;
        font-size: 13px;
        line-height: 16px;
      }
    }

    &-notification {
      position: relative;
      margin-left: 10px;
      cursor: pointer;
      z-index: 2;

      &_circle {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 8px;
        height: 8px;
        top: 1px;
        left: 2px;
        border: 2px solid $color-white;
        box-sizing: border-box;
        border-radius: 50%;
        background: $color-red;
      }

      &__image {
        width: 20px;
        height: 18px;
        object-fit: cover;
      }
    }

    &-mark {
      margin: auto 10px auto 5px;
      padding: 3px 4px;
      background: rgba($color-accent, 0.2);
      border-radius: 2px;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      color: $color-accent;
      max-height: 19px;
    }

    &-update {
      display: flex;
      width: 21px;
      height: 21px;
      align-items: center;
      justify-content: center;
      font-size: 9px;
      color: $color-accent;
      padding: 5px;
      cursor: pointer;
      transition: 0.3s;
      margin-right: 13px;
      background: $color-wild-sand;
      border-radius: 50%;

      &_disabled {
        color: $color-silver;
      }

      &:hover {
        color: $color-accent-hover;
      }
    }

    &-info {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      font-size: 13px;
      color: $color-silver;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        color: $color-dusty-gray;
      }

      &-popup {
        @include global-font;
        position: absolute;
        display: inline;
        padding: 7px;
        background: rgba($color-black, 0.55);
        border-radius: 5px;
        color: $color-white;
        user-select: none;
        pointer-events: none;
        max-width: 60vw;
        word-break: break-word;

        &-item {
          display: grid;
          grid-template-columns: 10px auto;
          grid-gap: 1px;
          align-items: start;
          margin-bottom: 5px;

          &__circle {
            width: 3px;
            height: 3px;
            margin: 5px 0;
            background-color: $color-white;
            border-radius: 50%;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }

        &:before {
          content: '';
          position: absolute;
          left: auto;
          top: -3px;
          display: block;
          width: 0;
          height: 0;
          border-left: 3px solid transparent;
          border-right: 3px solid transparent;
          border-bottom: 3px solid rgba($color-black, 0.55);
        }
      }
    }

    &__file {
      margin-left: 10px;
    }
  }

  .bbp-string-cell-popup {
    position: absolute;
    left: auto;
    top: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    padding: 4px 7px;
    background: rgba($color-black, 0.55);
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    color: $color-white;
    border-radius: 3px;
    z-index: 20;
    text-transform: capitalize;
    cursor: pointer;

    &:before {
      content: '';
      position: absolute;
      left: auto;
      top: -3px;
      display: block;
      width: 0;
      height: 0;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      border-bottom: 3px solid rgba($color-black, 0.55);;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPStringCell/BBPStringCell.vue